module.exports = __webpack_public_path__ + "img/triangle_phone-top.cc0d3ade.png";